export function setMockedDate(overrideDate: Date | string) {
    let dateOffset = new Date().getTime() - new Date(overrideDate as string).getTime(); // "new Date()" is allowed here
    let w = window as any;
    let originalDate = Date;
    w.Date = function () {
        if (arguments && arguments.length > 0) {
            let args = Array.prototype.slice.call(arguments);
            return new (originalDate as any)(...args);
        }
        return new originalDate(new originalDate().getTime() - dateOffset);
    };
    w.Date.prototype = originalDate.prototype;
    w.Date.now = () => w.Date().getTime();
    w.Date.OriginalDate = originalDate;
    w.Date.UTC = originalDate.UTC.bind(originalDate);
    w.Date.parse = s => originalDate.parse(s);
}

export function isDateMocked() {
    return "OriginalDate" in (window as any).Date;
}

export function restoreMockedDate() {
    if (isDateMocked()) {
        let w = window as any;
        let originalDate = w.Date.OriginalDate;
        w.Date = originalDate;
    }
}
